import { DefaultNotificationPermission, DeniedNotificationPermission, GrantedNotificationPermission, } from "./notification.types";
const denyNotificationsRequests = function () {
    window.Notification.requestPermission = async function () {
        return await new Promise((resolve) => {
            resolve(window.Notification.permission === DefaultNotificationPermission
                ? GrantedNotificationPermission
                : DeniedNotificationPermission);
        });
    };
};
denyNotificationsRequests();
